export default "/_next/static/assets/images/logo-ringier.15d33a6e6c470fdb4a31ad2741bda9eb.svg";